import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHorizontalAlignmentBottom"><Path d="M3.5 20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 7.5V17.5H17.5V7.5H13.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 3.5V17.5H10.5V3.5H6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHorizontalAlignmentBottom;
